import Option from './option'
import OATPrice from './price'

export default class Product {
  constructor({ description, figures, id,  name, options, slug, variants }) {
    this.description = description;
    this.figures = [];
    
    if(!['', null, undefined].includes(figures.picture)){
      this.figures.push(figures.picture);
    }

    if(figures.additionalPictures.length > 0) {
      figures.additionalPictures.forEach(fig => this.figures.push(fig));
    }

    this.id = id;
    this.name = name;
    this._options = options;
    this.slug = slug;
    this._variants = variants;
  }

  get options() { return this._options; }
  set options(options) {
    this._options = options.map(o => new Option(Option.format(o)));
  }

  get price() { 
    const prices = this._variants.map(v => v.unit_price);
    return new OATPrice({ prices });
  }

  get promoPrice() { 
    const prices = this._variants.map(v => v.promo_price);
    return new OATPrice({ prices });
  }

  get variants() { return this._variants; }

  static format(product) {
    return {
      description: product.descr,
      figures: {
        picture: product.picture,
        additionalPictures: product.additional_pictures,
      },
      id: product.id,
      name: product.title,
      options: product.options,
      price: product.variants[0].unit_price,
      slug: product.slug,
      variants: product.variants,
    };
  }

  static fromJSON(json) {
    const options = json._options.map(o => new Option(Option.fromJSON(o)));
    const additionalPictures = json.figures.filter((fig, i) => {
      return i !== 0;
    });

    return new Product({
      description: json.descr,
      figures: {
        picture: json.figures.length ? json.figures[0] : null,
        additionalPictures: additionalPictures,
      },
      id: json.id,
      name: json.name,
      options: options,
      price: json._variants[0].unit_price,
      slug: json.slug,
      variants: json._variants,
    });
  }
} 